'use client';

import {
  ActionIcon,
  Accordion,
  Button,
  Card,
  Checkbox,
  createTheme,
  Dialog,
  Divider,
  Drawer,
  HoverCard,
  Input,
  Menu,
  Modal,
  Pagination,
  ScrollArea,
  Select,
  Skeleton,
  Table,
  Tabs,
  TextInput,
  Code,
  Blockquote,
  Popover,
  UnstyledButton,
} from '@mantine/core';
import { DateTimePicker } from '@mantine/dates';
import { Notifications } from '@mantine/notifications';
import classes from './theme.module.css';

export const theme = createTheme({
  fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
  components: {
    ActionIcon: ActionIcon.extend({
      defaultProps: {
        color: 'rgb(60, 60, 120)',
        variant: 'filled',
      },
      classNames: {
        root: classes.buttonRoot,
      },
    }),
    Accordion: Accordion.extend({
      classNames: {
        control: classes.accordionControl,
        item: classes.accordionItem,
      },
    }),
    Button: Button.extend({
      classNames: {
        root: classes.buttonRoot,
      },
    }),
    Blockquote: Blockquote.extend({
      defaultProps: {
        iconSize: 32,
        color: 'violet',
        py: 10,
        px: 15,
        mt: 20,
        ml: 5,
        mb: 10,
      },
      classNames: {
        icon: classes.codeRoot,
      },
    }),
    Card: Card.extend({
      classNames: {
        root: classes.cardRoot,
      },
    }),
    Checkbox: Checkbox.extend({
      classNames: {
        input: classes.checkboxInput,
      },
    }),
    Code: Code.extend({
      defaultProps: {
        block: true,
        mt: 15,
        mb: 10,
        px: 20,
      },
      classNames: {
        root: classes.codeRoot,
      },
    }),
    Dialog: Dialog.extend({
      classNames: {
        root: classes.dialogRoot,
      },
    }),
    Divider: Divider.extend({
      classNames: {
        root: classes.dividerRoot,
      },
    }),
    Drawer: Drawer.extend({
      classNames: {
        header: classes.drawerHeader,
        body: classes.drawerBody,
      },
    }),
    HoverCard: HoverCard.extend({
      classNames: {
        dropdown: classes.hoverCardDropdown,
      },
    }),
    Input: Input.extend({
      classNames: {
        input: classes.inputInput,
      },
    }),
    Menu: Menu.extend({
      classNames: {
        dropdown: classes.menuDropdown,
        item: classes.menuItem,
      },
    }),
    Modal: Modal.extend({
      classNames: {
        content: classes.modalContent,
        header: classes.modalHeader,
      },
    }),
    Pagination: Pagination.extend({
      classNames: {
        control: classes.paginationControl,
      },
    }),
    ScrollArea: ScrollArea.extend({
      classNames: {
        scrollbar: classes.scrollAreaScrollbar,
      },
    }),
    Select: Select.extend({
      classNames: {
        dropdown: classes.menuDropdown,
        option: classes.menuItem,
      },
    }),
    Skeleton: Skeleton.extend({
      classNames: {
        root: classes.skeletonRoot,
      },
    }),
    Table: Table.extend({
      classNames: {
        table: classes.table,
        thead: classes.thead,
        tbody: classes.tbody,
        tr: classes.tr,
      },
    }),
    Tabs: Tabs.extend({
      classNames: {
        list: classes.tabsList,
      },
    }),
    TextInput: TextInput.extend({
      classNames: {
        input: classes.inputInput,
      },
    }),
    Popover: Popover.extend({
      classNames: {
        dropdown: classes.cardRoot,
      },
    }),
    Notifications: Notifications.extend({
      defaultProps: {
        autoClose: 6000,
      },
      classNames: {
        root: classes.notificationsRoot,
        notification: classes.notificationsNotification,
      },
    }),
    DateTimePicker: DateTimePicker.extend({
      defaultProps: {
        valueFormat: 'DD-MM-YYYY HH:mm',
        clearable: true,
      },
      classNames: {
        calendarHeaderLevel: classes.dateTimePicker,
        levelsGroup: classes.dateTimePicker,
        timeWrapper: classes.dateTimePickerTime,
      },
    }),
  },
});
